import { addModal } from 'modules/messageSystem/actions/addModal';
import * as modalCodes from 'modules/messageSystem/constants/modalCodes';

export const invokeAppointmentForwardingConsentModal = ({ appointmentId, onOk, onCancel }) => addModal({
  testId: 'appointment-forwarding-consent-modal',
  typeId: modalCodes.APPOINTMENT_FORWARDING_CONSENT_MODAL,
  preventClosingWhenDismiss: true,
  canAddDuplicate: false,
  isForce: true,
  bodyValues: { appointmentId },
  onOk,
  onCancel,
});
